import 'angular:locale/data:es';
import 'angular:locale/data:it';
import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import 'angular:locale/data:de';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
